// Auth action type constants
export const LOGIN = 'LOGIN';
export const SET_MFA = 'SET_MFA';
export const NAV_TOGGLE = 'NAV_TOGGLE';
export const USER_LOGOUT = 'USER_LOGOUT';
export const SAVE_TABLE_PREF = 'SAVE_TABLE_PREF';
export const SAVE_TABLE_PAGESIZE = 'SAVE_TABLE_PAGESIZE';
export const SAVE_QUERY_SESSION = 'SAVE_QUERY_SESSION';
export const SAVE_PREFERENCES_STATE = 'SAVE_PREFERENCES_STATE';
export const SET_FEATURE_FLAGS = 'SET_FEATURE_FLAGS';

// Type union for auth action types
export type AuthActionType =
  | typeof LOGIN
  | typeof SET_MFA
  | typeof NAV_TOGGLE
  | typeof USER_LOGOUT
  | typeof SAVE_TABLE_PREF
  | typeof SAVE_TABLE_PAGESIZE
  | typeof SAVE_QUERY_SESSION
  | typeof SAVE_PREFERENCES_STATE
  | typeof SET_FEATURE_FLAGS;
